export default {
  'exportRecords.title': 'Export Records',
  'exportRecords.form.taskType': 'Export Type',
  'exportRecords.form.taskType.placeholder': 'Select export type',
  'exportRecords.form.status': 'Status',
  'exportRecords.form.status.placeholder': 'Select status',
  'exportRecords.form.search': 'Search',
  'exportRecords.form.reset': 'Reset',
  'exportRecords.type.orders': 'Order List',
  'exportRecords.type.subscription-orders': 'Subscription Orders',
  'exportRecords.type.subscription': 'Subscription Records',
  'exportRecords.status.pending': 'Queued',
  'exportRecords.status.processing': 'Exporting',
  'exportRecords.status.success': 'Done',
  'exportRecords.status.failed': 'Failed',
  'exportRecords.columns.index': '#',
  'exportRecords.columns.fileName': 'File Name',
  'exportRecords.columns.taskType': 'Export Type',
  'exportRecords.columns.status': 'Status',
  'exportRecords.columns.progress': 'Progress',
  'exportRecords.columns.totalRows': 'Rows',
  'exportRecords.columns.createdAt': 'Created At',
  'exportRecords.columns.finishedAt': 'Finished At',
  'exportRecords.columns.operations': 'Actions',
  'exportRecords.operations.download': 'Download',
  'exportRecords.operations.downloadStarted': 'Download started',
  'exportRecords.operations.unavailable': 'File unavailable',
  'exportRecords.operations.delete': 'Delete',
  'exportRecords.operations.deleteConfirm':
    'Delete this export record? This cannot be undone.',
  'exportRecords.operations.deleteSuccess': 'Deleted successfully',
  'exportRecords.operations.deleteError': 'Failed to delete',
  'exportRecords.operations.deleteMissingId': 'Missing task ID, cannot delete',
  'exportRecords.operations.deleteMissingType':
    'Missing export type, cannot delete',
  'exportRecords.operations.batchDelete': 'Batch Delete',
  'exportRecords.operations.batchDeleteConfirm':
    'Delete selected export records? This cannot be undone.',
  'exportRecords.operations.batchDeleteEmpty':
    'Please select records to delete',
  'exportRecords.operations.batchDeleteSuccess': 'Batch deleted successfully',
  'exportRecords.operations.loadError': 'Failed to load export records',
  'exportRecords.empty': 'No export records yet',
};
